import { render, staticRenderFns } from "./TypeOrder.vue?vue&type=template&id=e20df49e&scoped=true&"
import script from "./TypeOrder.vue?vue&type=script&lang=js&"
export * from "./TypeOrder.vue?vue&type=script&lang=js&"
import style0 from "./TypeOrder.vue?vue&type=style&index=0&id=e20df49e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e20df49e",
  null
  
)

export default component.exports